import { Expose, Type } from 'class-transformer';
import { LinkProps } from '@/models/widgets/props/link';

class FillingElements {
  @Expose()
  key!: string;

  @Expose()
  @Type(() => LinkProps)
  element!: LinkProps;
}
export class CheckboxProps {
  @Expose({ name: 'label' })
  label!: string;

  @Expose()
  @Type(() => FillingElements)
  fillingElements!: FillingElements[];

  @Expose()
  value!: boolean;
}
